import React, { useContext, useMemo } from "react";
import { AppContext } from "../../providers/Redux/Reducers/AppContext";
import { useHistory } from "react-router-dom";

// Import Ionic Components
import { IonButton, IonCol, IonGrid, IonIcon, IonLoading, IonRow } from "@ionic/react";

// Import Icons
import { heart } from "ionicons/icons";

// Import Styles
import classNames from "classnames/bind";
import styles from "./Wishlist.module.scss";
import "./Wishlist.scss";

// Import Components
import MaxWidthContainer from "../../components/UI/MaxWidthContainer/MaxWidthContainer";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useWishListData } from "../../providers/wishListStore";
import { useGetIncludeProductsQuery } from "../../providers/products";
import useIsViewFocused from "../../hooks/useIsViewFocused";
import Page from "../page-layout";
import { NewListViewProduct } from "@core/components";
import { useActiveOrMainShippingZone } from "../../providers/shippingZones";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const Wishlist: React.FC = () => {
  const { state } = useContext(AppContext);
  const { t } = useTranslation();
  const { wishListProducts: wishListProductsIds } = useWishListData();
  let history = useHistory();

  const isViewFocused = useIsViewFocused();

  const { activeShippingZone } = useActiveOrMainShippingZone();

  const { data: wishlistProducts, isFetching: isWishListFetching } = useGetIncludeProductsQuery({
    include: wishListProductsIds,
    params: {
      zoneId: activeShippingZone.id,
    },
    options: {
      enabled: !!wishListProductsIds.length && isViewFocused,
    },
  });

  const openProductsPage = () => {
    history.push("search-main-categories");
  };

  return (
    <Page>
      <Page.HeaderMobile showSearchButton={true} />

      <Page.Content>
        <Page.HeaderDesktop breadcrumbs={[{ title: t("Favourite") }]} />
        <MaxWidthContainer
          classList={`global-content h-full ${cx({ "empty-list": state.config.wishListProducts.length === 0 })}`}
        >
          <PageTitle hideTitleBreakpoint={"ion-hide-md-down"} title={t("Favourite")} />
          {wishListProductsIds.length === 0 ? (
            <IonGrid className="ion-no-padding grid-wish-list">
              <IonRow>
                <IonCol size="12">
                  <IonIcon className="no-margin-icon" icon={heart} />
                </IonCol>
                <IonCol size="12">
                  <h4>{t("Your wish List is empty")}</h4>
                </IonCol>
                <IonCol size="12">
                  <IonButton onClick={() => openProductsPage()}>{t("Explore")}</IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
          ) : (
            <IonGrid className={cx("wishList__container")}>
              <IonRow>
                <IonLoading isOpen={isWishListFetching} message={t("Please wait...")} duration={20000} />
                {wishlistProducts?.map((p: any, i: number) => (
                  <IonCol key={p.id} size={"12"} sizeSm={"3"} sizeMd={"2.3"} sizeLg={"2"} sizeXl={"1.5"}>
                    <NewListViewProduct product={p} type="list-for-wish" />
                  </IonCol>
                ))}
              </IonRow>
            </IonGrid>
          )}
        </MaxWidthContainer>
        <Page.ContentFooter />
      </Page.Content>
    </Page>
  );
};

export default Wishlist;
